module.exports = __webpack_public_path__ + "static/media/03.ae59c5cc.jpg";